import { createContext } from 'react';

type ContextType = {
  unlockNextStateAndNavigate: () => void;
  goToNextState: () => void;
  goToPreviousState: () => void;
};

export const ProposalCreationContext = createContext<ContextType>({
  unlockNextStateAndNavigate: () => {},
  goToNextState: () => {},
  goToPreviousState: () => {},
});
